module.exports = __webpack_public_path__ + "1684d4e2b7efe8e1b23599a8b25c8bba.png";